export const FullScreenCenter = ({ children }) => {
  return (
    <div className="flex h-screen w-screen items-start justify-center">
      <div className="mt-[8%]">{children}</div>
    </div>
  );
};
